/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceOwnerClientResponseDto } from './DeviceOwnerClientResponseDto';
import type { DeviceRoomResponseDto } from './DeviceRoomResponseDto';
import type { DeviceTenantResponseDto } from './DeviceTenantResponseDto';
export type DeviceUpdateResponseDto = {
  /**
   * Unique serial number of the device.
   */
  serialNumber: string;
  /**
   * Device type (e.g., A1).
   */
  type: string;
  /**
   * Current operational status of the device.
   */
  status: DeviceUpdateResponseDto.status;
  /**
   * Current firmware version installed on the device.
   */
  firmwareVersion: string;
  /**
   * Timestamp when the device was first registered in the system.
   */
  registeredAt: string;
  /**
   * Timestamp when the device was last activated.
   */
  lastActivatedAt: string;
  /**
   * Indicates whether a fault event has been reported by the device.
   */
  faulty: boolean;
  /**
   * Indicates whether the device is connected to an external power source.
   */
  externalPowerSource?: boolean;
  /**
   * Information about the assigned device owner (if any).
   */
  owner?: DeviceOwnerClientResponseDto;
  /**
   * Information about the tenant that owns the device.
   */
  tenant?: DeviceTenantResponseDto;
  /**
   * Information about the room where the device is placed.
   */
  room?: DeviceRoomResponseDto;
  /**
   * Display name of the device.
   */
  name?: string;
  /**
   * Timestamp when the device was last suspended.
   */
  lastSuspendedAt?: string;
  /**
   * Timestamp when the device was last deactivated.
   */
  lastDeactivatedAt?: string;
  /**
   * Timestamp of the last uplink message received from the device.
   */
  lastUplinkAt?: string;
  /**
   * Timestamp when the device last renewed.
   */
  lastRenewedAt?: string;
  /**
   * Timestamp when the device was assigned to the current owner.
   */
  ownerAssignedAt?: string;
  /**
   * Integrated Circuit Card Identifier (SIM card ID) of the device (if applicable).
   */
  iccid?: string;
  /**
   * Current health status of the device.
   */
  healthStatus: DeviceUpdateResponseDto.healthStatus;
  /**
   * Indicates whether the activation code is enabled.
   */
  activationCodeEnabled?: boolean;
  /**
   * Updated status of the device.
   */
  targetStatus: DeviceUpdateResponseDto.targetStatus;
};
export namespace DeviceUpdateResponseDto {
  /**
   * Current operational status of the device.
   */
  export enum status {
    NEW = 'NEW',
    NEW_IN_PROGRESS = 'NEW_IN_PROGRESS',
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    FOR_RETURN = 'FOR_RETURN',
    FOR_RETURN_IN_PROGRESS = 'FOR_RETURN_IN_PROGRESS',
    RESET = 'RESET',
    RESET_IN_PROGRESS = 'RESET_IN_PROGRESS',
  }
  /**
   * Current health status of the device.
   */
  export enum healthStatus {
    UNKNOWN = 'UNKNOWN',
    HEALTHY = 'HEALTHY',
    COMMUNICATION_ERROR = 'COMMUNICATION_ERROR',
    FOR_RETURN = 'FOR_RETURN',
  }
  /**
   * Updated status of the device.
   */
  export enum targetStatus {
    NEW = 'NEW',
    NEW_IN_PROGRESS = 'NEW_IN_PROGRESS',
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    FOR_RETURN = 'FOR_RETURN',
    FOR_RETURN_IN_PROGRESS = 'FOR_RETURN_IN_PROGRESS',
    RESET = 'RESET',
    RESET_IN_PROGRESS = 'RESET_IN_PROGRESS',
  }
}

